import CriteriaService from "@/services/CriteriaService";

import {useEffect, useMemo, useState} from "react";

import {Spinner} from "@ui/general/Spinner";

import {ScenarioCriteriaList} from "./ScenarioCriteriaList";
import {buildScenarioCriteriaDisplayOptions} from "./scenarioCriteriaHelpers";

export const ScenarioCriteriaView = ({evaluationTemplateId}) => {
  const [templateTarget, setTemplateTarget] = useState(null);
  const [loadingTemplate, setLoadingTemplate] = useState(false);

  useEffect(() => {
    if (!evaluationTemplateId) {
      setTemplateTarget(null);
      return undefined;
    }

    let cancelled = false;

    setLoadingTemplate(true);
    CriteriaService.viewCriteria({id: evaluationTemplateId})
      .then((response) => {
        if (!cancelled) {
          setTemplateTarget(response.data);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoadingTemplate(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [evaluationTemplateId]);

  const criteriaOptions = useMemo(
    () => buildScenarioCriteriaDisplayOptions(templateTarget),
    [templateTarget],
  );

  if (loadingTemplate) {
    return (
      <Spinner
        width={32}
        height={32}
      />
    );
  }

  if (!criteriaOptions.length) {
    return <>-</>;
  }

  return <ScenarioCriteriaList criteriaOptions={criteriaOptions} />;
};
